import api from '../../api'

export async function getAllows() {
  return api.get('rtpi_print/allows');
}

export async function getRtpis(query, numOfRegisters = 10, page = 1, order, branch) {
  const params = {
    order: order ? order : 'protheusCode',
    only_registered: true,
  }
  if (query) {
    params.query = query.trim(); 
  }
  if (branch) {
    params.branch = branch; 
  }
  
  return api.get('rtpi_print', {
    params,
    headers: {
      registerperpage: numOfRegisters,
      page
    }
  });
}

export async function getRtpiReport(branch, protheusCode, revision = null) {
  let url = `rtpi_print/${branch}/${protheusCode}/report`;
  
  if (revision) {
    url = `rtpi_print/${branch}/${protheusCode}/${revision}/report`;
  }

  return api.get(url, {responseType: 'blob'});
}

export async function getWarrantyLevelReport(branch, protheusCode, revision = null) {
  let url = `rtpi_print/${branch}/${protheusCode}/warrantylevel/report`;
  
  if (revision) {
    url = `rtpi_print/${branch}/${protheusCode}/${revision}/warrantylevel/report`;
  }

  return api.get(url, {responseType: 'blob'});
}

export async function rtpiFlagPrint(branch, protheusCode, revision = null) {
  let url = `rtpi_print/print/${branch}/${protheusCode}/${revision}`;

  return api.put(url);
}

export async function findBranch(query, numOfRegisters = 6) {
  return api.get('rtpi_print/branches', {
    params: {
      query,
      order: 'description'
    },
    headers: {
      registerperpage: numOfRegisters,
      page: 1
    }
  });
}
